import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, IconButton, styled, useTheme,  Checkbox } from "@mui/material";
import alignCenter from "assets/icons/aligncenter.svg";
import moment from "moment";
import PaginationComponent from "components/ui-components/PaginationComponent";


const StyledTableHead = styled(TableCell)({
    fontWeight: 500,
    fontSize: "14px",
    color: "#505258",
    padding: "8px 10px",
    backgroundColor: "#F8F8F8",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    whiteSpace: "nowrap",
    letterSpacing: "-0.2px",
    lineHeight: "20px",
});

const StyledTableBody = styled(TableCell)({
    fontWeight: 400,
    fontSize: "14px",
    color: "#5052588A",
    padding: "8px 10px",
    backgroundColor: "#fff",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    lineHeight: "20px",
    letterSpacing: "-0.2px",
    whiteSpace: "nowrap",
});

const StyledSkeletonCell = styled(TableCell)({
    padding: "10px 14px",
    border: "1px solid #D8D8D8",
    textAlign: "center",
    backgroundColor: "#fff",
});

const data = [
  {
    contractNumber: "CN-2025-001",
    invoiceNumber: "INV-1001",
    contractorName: "ABC Constructions Pvt Ltd",
    paymentType: "Advance",
    statusAsOn: "Pending",
  },
  {
    contractNumber: "CN-2025-002",
    invoiceNumber: "INV-1002",
    contractorName: "XYZ Builders",
    paymentType: "Final Payment",
    statusAsOn: "Completed",
  },
  {
    contractNumber: "CN-2025-003",
    invoiceNumber: "INV-1003",
    contractorName: "MNO Contractors",
    paymentType: "Progress Payment",
    statusAsOn: "In Progress",
  },
  {
    contractNumber: "CN-2025-004",
    invoiceNumber: "INV-1004",
    contractorName: "PQR Infra Ltd",
    paymentType: "Retention",
    statusAsOn: "Hold",
  },
  {
    contractNumber: "CN-2025-005",
    invoiceNumber: "INV-1005",
    contractorName: "LMN Engineering",
    paymentType: "Advance",
    statusAsOn: "Completed",
  },
   {
    contractNumber: "CN-2025-001",
    invoiceNumber: "INV-1001",
    contractorName: "ABC Constructions Pvt Ltd",
    paymentType: "Advance",
    statusAsOn: "Pending",
  },
  {
    contractNumber: "CN-2025-002",
    invoiceNumber: "INV-1002",
    contractorName: "XYZ Builders",
    paymentType: "Final Payment",
    statusAsOn: "Completed",
  },
  {
    contractNumber: "CN-2025-003",
    invoiceNumber: "INV-1003",
    contractorName: "MNO Contractors",
    paymentType: "Progress Payment",
    statusAsOn: "In Progress",
  },
  {
    contractNumber: "CN-2025-004",
    invoiceNumber: "INV-1004",
    contractorName: "PQR Infra Ltd",
    paymentType: "Retention",
    statusAsOn: "Hold",
  },
  {
    contractNumber: "CN-2025-005",
    invoiceNumber: "INV-1005",
    contractorName: "LMN Engineering",
    paymentType: "Advance",
    statusAsOn: "Completed",
  },
  

];




const InvoiceListPaymentTracker = () => {
     const [currentPage, setCurrentPage] = useState(1);
        const theme = useTheme();
    
        const rowsPerPage = 8;
        const totalPages = Math.ceil(data.length / rowsPerPage);
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        const currentRows = data?.slice(startIndex, endIndex);
    
    // if (isLoading) {
    //     return (
    //       <Paper
    //         sx={{
    //           boxShadow: "none",
    //           marginTop: "20px",
    //           paddingBottom: "18px",
    //           borderRadius: "5px",
    //           minHeight: "400px",
    //         }}
    //       >
    //         <TableContainer>
    //           <Table>
    //             <TableHead>
    //               <TableRow>
    //                 {[...Array(4)].map((_, i) => (
    //                   <StyledSkeletonCell key={i}>
    //                     <Box sx={{ py: 2 }}>
    //                       <Skeleton
    //                         variant="rectangular"
    //                         width={i === 0 ? 20 : 80}
    //                         height={15}
    //                       />
    //                     </Box>
    //                   </StyledSkeletonCell>
    //                 ))}
    //               </TableRow>
    //             </TableHead>
    //             <TableBody>
    //               {[...Array(5)].map((_, index) => (
    //                 <TableRow key={index}>
    //                   {[...Array(4)].map((_, i) => (
    //                     <StyledSkeletonCell key={i}>
    //                       <Box sx={{ py: 1 }}>
    //                         <Skeleton
    //                           variant={i === 0 ? "circular" : "text"}
    //                           width={i === 0 ? 18 : "90%"}
    //                           height={20}
    //                         />
    //                       </Box>
    //                     </StyledSkeletonCell>
    //                   ))}
    //                 </TableRow>
    //               ))}
    //             </TableBody>
    //           </Table>
    //         </TableContainer>
    //       </Paper>
    //     );
    //   }

    return (
        <>
                <Box
                    sx={{
                        width: "100%",
                        height: "471px",
                        border: "1px solid #2525252E",
                        mt: 0,
                        mb:0,
                        borderRadius: "7px",
                        overflow: "hidden",
                        backgroundColor: "white",
                        position: "relative",
                        
                    }}
                >
                    <Box sx={{ p: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 500,
                                fontSize: "18px",
                                lineHeight: "100%",
                                letterSpacing: "-0.4px",
                                color: `${theme?.customSettings?.themeColor}`,
                            }}
                        >
                            Invoice List
                        </Typography>
                        {/* <Typography
                            sx={{
                                mt: "8px",
                                color: "#5052588A",
                                fontSize: "14px",
                                lineHeight: "100%",
                                letterSpacing: "-0.4px",
                            }}
                        >
                            Get a holistic view of how work is being prioritized
                        </Typography> */}
                    </Box>
                    <TableContainer sx={{mt:"24px"}}>
                        <Table sx={{ width: "100%", border: "1px solid #D8D8D8", }}>
                            <TableHead>
                                <TableRow>
                                    {["Contract Number", "Invoice Number", "Name of Contractor", "Type of Payment", "Status as On"].map(
                                        (header) => (
                                            <StyledTableHead key={header}>{header}</StyledTableHead>
                                        )
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={4}
                                            align="center"
                                            sx={{ py: 4, color: "#999", fontSize: "16px" }}
                                        >
                                            No record found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    currentRows.map((row, index) => (
                                        <TableRow key={index}>
                                            <StyledTableBody>
                                                {row.contractNumber}
                                            </StyledTableBody>
                                            <StyledTableBody>{row.invoiceNumber}</StyledTableBody>
                                            <StyledTableBody>{row.contractorName}</StyledTableBody>
                                            <StyledTableBody>{row.paymentType}</StyledTableBody>
                                            <StyledTableBody>{row.statusAsOn}</StyledTableBody>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box
                        sx={{
                            position: "absolute",
                            mb: "10px",
                            right: 0,
                            mt:0,
                            padding: "12px 16px",
                            backgroundColor: "#fff",
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        {/* {!isLoading && ( */}
                        <PaginationComponent
                            pageNumber={currentPage}
                            totalPages={totalPages || 1}
                            onPageChange={setCurrentPage}
                        />
                        {/* )} */}
                    </Box>
                </Box>

        </>
    );

   
};

export default InvoiceListPaymentTracker;
